import React, { useCallback, useEffect, useState } from 'react';
const names = ['Marco R.', 'Giulia B.', 'Alessandro C.', 'Francesca M.', 'Matteo S.', 'Chiara L.', 'Lorenzo P.', 'Valentina D.'];
const cities = ['Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Genova', 'Bologna', 'Firenze'];
const products = ['Combo Scienze (Fisica + Chimica)', 'Combo Scienze (Fisica + Chimica)', 'Fisica Pronta', 'Fisica Pronta'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
    product: string;
    time: string;
  } | null>(null);
  const show = useCallback(() => {
    setNotification({
      name: randomItem(names),
      city: randomItem(cities),
      product: randomItem(products),
      time: String(Math.floor(Math.random() * 15) + 2)
    });
    setTimeout(() => {
      setNotification(null);
      setTimeout(show, Math.floor(Math.random() * 25000) + 25000);
    }, 4000);
  }, []);
  useEffect(() => {
    // Defer the first notification to browser idle time AND keep the 15s minimum
    // delay so it never competes with initial paint or first interaction.
    let firstTimer: number | null = null;
    let idleHandle: any = null;
    firstTimer = window.setTimeout(() => {
      const w = window as any;
      const idle = w.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 200));
      idleHandle = idle(show);
    }, 15000);
    return () => {
      if (firstTimer != null) clearTimeout(firstTimer);
      const w = window as any;
      if (idleHandle && w.cancelIdleCallback) {
        try {
          w.cancelIdleCallback(idleHandle);
        } catch {}
      }
    };
  }, [show]);
  if (!notification) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none" data-id="element-243">
      <div className="flex items-start gap-3" data-id="element-244">
        <span className="text-brand-accent text-sm mt-0.5" data-id="element-245">✅</span>
        <div data-id="element-246">
          <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-247">
            Acquisto verificato
          </div>
          <div className="text-xs text-white leading-tight mb-0.5" data-id="element-248">
            <span className="font-bold" data-id="element-249">{notification.name}</span> di{' '}
            {notification.city}
          </div>
          <div className="text-[11px] text-white/70 leading-tight mb-1.5" data-id="element-250">
            ha comprato{' '}
            <span className="font-bold text-white" data-id="element-251">{notification.product}</span>{' '}
            🔬
          </div>
          <div className="text-[10px] text-white/60 italic font-medium" data-id="element-252">
            fa {notification.time} minuti
          </div>
        </div>
      </div>
    </div>;
}